import React from "react";
import { TextInput } from "../ui/FormControls";
import { cn } from "../../lib/utils";

export const PRODUCT_LIST_SEARCH_PLACEHOLDER = {
  credentials: "Search name, issuer, or person",
  jobs: "Search name or address",
} as const;

type ProductListSearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  className?: string;
};

export const ProductListSearch: React.FC<ProductListSearchProps> = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  className,
}) => (
  <div className={cn("min-w-0 flex-1", className)}>
    <TextInput
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel}
    />
  </div>
);

type ProductListFilterFieldProps = {
  id: string;
  label: string;
  children: React.ReactNode;
};

export const ProductListFilterField: React.FC<ProductListFilterFieldProps> = ({
  id,
  label,
  children,
}) => (
  <div>
    <label
      htmlFor={id}
      className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-muted-foreground"
    >
      {label}
    </label>
    {children}
  </div>
);

type ProductListToolbarProps = {
  search: ProductListSearchProps;
  filters?: React.ReactNode;
};

export const ProductListToolbar: React.FC<ProductListToolbarProps> = ({
  search,
  filters,
}) => (
  <div className="flex flex-col gap-4 lg:flex-row lg:items-end">
    <ProductListSearch {...search} />
    {filters ? (
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">{filters}</div>
    ) : null}
  </div>
);

export const ProductListEmptyFiltersMessage: React.FC = () => (
  <p className="text-sm text-muted-foreground">Nothing matches that search.</p>
);
